import { render } from "./GetZip.vue?vue&type=template&id=5e4bb65c"
import script from "./GetZip.ts?vue&type=script&lang=js&external"
export * from "./GetZip.ts?vue&type=script&lang=js&external"

import "./GetZip.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__